import { AnalyticsTransformer, TrackingData } from '@panamax/app-state';

export const PaymentPreferencesPageLoad: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  page: {
    pageName: tracking.data.pageName,
  },
  customerCount: tracking.data.counts.customers,
  file: {
    fileCount: tracking.data.counts.manualDeductAccounts,
    autopayCount: tracking.data.counts.autopayAccounts,
  },
});

export const PaymentPreferencesAddBankAccount: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  page: {
    pageName: tracking.data.pageName,
  },
  customerCount: tracking.data.counts.customers,
  file: {
    type: tracking.data.bankAccountType,
    status: tracking.data.newOrExistingAccount,
  },
});

export const PaymentPreferencesAutopaySetupStarted: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  button: { buttonName: tracking.data.buttonName },
});
